import { Alert, Button, Card, CardContent, Chip, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ApiLojaGet } from "data/ApiLoja";
import { requestCertificateAction } from "./certificateAdminApi";
import { certificateStatusLabel } from "./attendanceLabels";

type Row = {
  id: number;
  name: string;
  email: string;
  participationStatus: string;
  certificateStatus: string;
  eligible: boolean;
  pending: string[];
  certificate?: { version: number; serialNumber: string };
};

export const CertificateManagement = ({ eventId }: { eventId: number }) => {
  const [rows, setRows] = useState<Row[]>([]);
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");

  const load = async () => {
    try {
      setError("");
      const response = await ApiLojaGet<{ registrations: Row[] }>(`/admin/events/${eventId}/certificates`);
      setRows(response.data.registrations);
    } catch (requestError: any) {
      setError(requestError?.response?.data?.message || "Não foi possível carregar os certificados.");
    }
  };

  useEffect(() => { void load(); }, [eventId]);

  const act = async (id: number, action: string) => {
    const needsReason = ["REVOKE", "REISSUE", "CORRECT_NAME"].includes(action);
    const reason = needsReason ? window.prompt("Motivo obrigatório:") || "" : "";
    if (needsReason && !reason) return;
    let participantName: string | undefined;
    if (action === "CORRECT_NAME") {
      participantName = window.prompt("Nome oficial corrigido:") || "";
      if (!participantName) return;
    }
    try {
      setError("");
      await requestCertificateAction(id, action, reason, participantName);
      await load();
    } catch (requestError: any) {
      setError(requestError?.response?.data?.message || "Não foi possível alterar o certificado.");
    }
  };

  const filtered = rows.filter((row) => `${row.name} ${row.email}`.toLowerCase().includes(search.toLowerCase()));

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Stack gap={2}>
          <Typography variant="h5">Certificados dos participantes</Typography>
          {error && <Alert severity="warning">{error}</Alert>}
          <TextField label="Pesquisar participante" value={search} onChange={(event) => setSearch(event.target.value)} />
          {filtered.map((row) => (
            <Stack key={row.id} gap={1} sx={{ borderBottom: "1px solid #ddd", pb: 2 }}>
              <Stack direction="row" gap={1} alignItems="center">
                <Typography flex={1}>{row.name} — {row.email}</Typography>
                <Chip label={certificateStatusLabel(row.certificateStatus)} />
              </Stack>
              {row.pending.length > 0 && <Typography variant="caption">{row.pending.join(" ")}</Typography>}
              <Stack direction="row" gap={1} flexWrap="wrap">
                {["AVAILABLE", "ISSUED"].includes(row.certificateStatus) && <Button onClick={() => act(row.id, "BLOCK")}>Bloquear</Button>}
                {row.certificateStatus === "BLOCKED" && <Button onClick={() => act(row.id, "UNBLOCK")}>Desbloquear</Button>}
                <Button onClick={() => act(row.id, "CORRECT_NAME")}>Corrigir nome</Button>
                <Button onClick={() => act(row.id, "REISSUE")}>Reemitir</Button>
                {row.certificateStatus !== "REVOKED" && <Button color="error" onClick={() => act(row.id, "REVOKE")}>Revogar</Button>}
              </Stack>
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
